import React from "react";
import { Typography, Box } from "@mui/material";
import { compose } from "underscore";

import { icons } from "../../constants";

const Message = ({ isRead, onClick, classes }) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", flex: 1 }}
      onClick={onClick}
    >
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "0 16px",
          justifyContent: "space-between",
          backgroundColor: !isRead && "#e5f4fb",
        }}
      >
        <Box sx={{ padding: "16px 0" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {!isRead && (
              <img
                src={icons.notificationUnread}
                alt="notification-unread"
                style={{ marginRight: "8px" }}
              />
            )}
            <Typography sx={{ fontWeight: "700",
    lineHeight: 1.38,
    color: "#162b3a"}}>
              Lorem ipsum dolor sit amet
            </Typography>
          </Box>
          <Typography className={`${classes.baseFont} ${classes.content}`}>
            Lorem ipsum dolor sit amet, autem splendide evertitur est ex. An
            putent possit argumentum mea.
          </Typography>
          <Typography className={`${classes.baseFont} ${classes.date}`}>
            14 Sep 2021 • 06.00PM
          </Typography>
        </Box>
        <div>
          <img src={icons.arrowRight} alt="arrow-right" />
        </div>
      </Box>
      <div className={classes.line} /> */}
    </Box>
  );
};

export default Message;
